// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Types of jobs that can be run in the background
 */
export type JobTypes = (typeof JobTypes)[keyof typeof JobTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobTypes = {
  test: 'test',
  bulk: 'bulk',
  autograde: 'autograde',
  process_resource: 'process_resource',
} as const;
